import Loading from '@doordash/component-loading';
import { ButtonType, ButtonSize, ButtonState } from './types.js';

var colorForType = function colorForType(_ref) {
  var isToggleable = _ref.isToggleable,
      isToggled = _ref.isToggled,
      buttonType = _ref.buttonType,
      isDisabled = _ref.isDisabled,
      isRaised = _ref.isRaised;

  switch (buttonType) {
    case ButtonType.FlatPrimary:
      return isDisabled ? 'ButtonFlatPrimaryForegroundDisabled' : 'ButtonFlatPrimaryForeground';

    case ButtonType.FlatSecondary:
      return isDisabled ? 'ButtonFlatSecondaryForegroundDisabled' : 'ButtonFlatSecondaryForeground';

    case ButtonType.Link:
      return isDisabled ? 'ButtonLinkForegroundDisabled' : 'ButtonLinkForeground';

    case ButtonType.Plain:
      return isRaised ? isDisabled ? 'ButtonFabForegroundDisabled' : 'ButtonFabForeground' : isDisabled ? 'ButtonPlainForegroundDisabled' : 'ButtonPlainForeground';

    case ButtonType.Secondary:
    case ButtonType.SecondaryPill:
      {
        if (isToggleable) {
          return isToggled ? isDisabled ? 'ButtonSecondaryToggleForegroundDisabled' : 'ButtonSecondaryToggleForeground' : isDisabled ? 'ButtonSecondaryToggleForegroundOffDisabled' : 'ButtonSecondaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonSecondaryForegroundDisabled' : 'ButtonSecondaryForeground';
      }

    case ButtonType.Tertiary:
    case ButtonType.TertiaryPill:
      {
        if (isToggleable) {
          return isToggled ? isDisabled ? 'ButtonTertiaryToggleForegroundDisabled' : 'ButtonTertiaryToggleForeground' : isDisabled ? 'ButtonTertiaryToggleForegroundOffDisabled' : 'ButtonTertiaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonTertiaryForegroundDisabled' : 'ButtonTertiaryForeground';
      }

    case ButtonType.Destructive:
      return isDisabled ? 'ButtonDestructiveForegroundDisabled' : 'ButtonDestructiveForeground';

    case ButtonType.Primary:
    case ButtonType.PrimaryPill:
    case ButtonType.Full:
    default:
      {
        if (isToggleable) {
          return isToggled ? isDisabled ? 'ButtonPrimaryToggleForegroundDisabled' : 'ButtonPrimaryToggleForeground' : isDisabled ? 'ButtonPrimaryToggleForegroundOffDisabled' : 'ButtonPrimaryToggleForegroundOff';
        }

        return isDisabled ? 'ButtonPrimaryForegroundDisabled' : 'ButtonPrimaryForeground';
      }
  }
};
var iconSizeForIconButton = function iconSizeForIconButton(buttonSize) {
  switch (buttonSize) {
    case ButtonSize.Small:
      return 'Small';

    case ButtonSize.Medium:
    case ButtonSize.Large:
    case ButtonSize.XLarge:
    default:
      return 'Medium';
  }
};
var loadingSizeForButton = function loadingSizeForButton(buttonSize) {
  switch (buttonSize) {
    case ButtonSize.Small:
      return 'Small';

    case ButtonSize.Large:
    case ButtonSize.XLarge:
      return 'Large';

    case ButtonSize.Medium:
    default:
      return 'Medium';
  }
};
var loadingStateForButton = function loadingStateForButton(buttonState) {
  switch (buttonState) {
    case ButtonState.Error:
      return Loading.States.Error;

    case ButtonState.Success:
      return Loading.States.Success;

    case ButtonState.Loading:
    default:
      return Loading.States.Loading;
  }
};

var generateTabIndex = function generateTabIndex(_ref2, isLink) {
  var isDisabled = _ref2.isDisabled,
      tag = _ref2.tag;

  // if link is disabled we will need to remove from focus order manually
  if (isDisabled && isLink) {
    return -1;
  } else if (tag !== 'button' && !isLink) {
    return 0;
  } else {
    return undefined;
  }
};

var generateRoleRelatedProps = function generateRoleRelatedProps(_ref3) {
  var isDisabled = _ref3.isDisabled,
      tag = _ref3.tag,
      href = _ref3.href,
      state = _ref3.state,
      _onClick = _ref3.onClick,
      accessibilityRole = _ref3.accessibilityRole;
  var isLinkComponent = typeof tag !== 'undefined' && typeof tag !== 'string';
  var isAnchor = tag === 'a';
  var hasHref = typeof href === 'string' && href.length > 0;
  var isLink = isAnchor || hasHref;
  return {
    // if `tag` is a component then use that, otherwise use `a` if we think this is a link
    as: isLinkComponent ? tag : isLink ? 'a' : tag,
    href: href,
    tabIndex: generateTabIndex({
      isDisabled: isDisabled,
      tag: tag
    }, isLink),
    role: typeof accessibilityRole !== 'undefined' ? accessibilityRole : tag !== 'button' && !isLink ? 'button' : undefined,
    type: !isLink && !accessibilityRole ? 'button' : null,
    // if a custom `accessibilityRole` is provided this is likely presumptuous
    disabled: tag === 'button' ? isDisabled : undefined,
    'aria-disabled': tag !== 'button' ? isDisabled : undefined,
    onClick: function onClick(event) {
      // if this is an anchor tag, we need to handle the disabled state ourselves,
      // as anchors don't really handle this natively
      var linkDisabled = isDisabled || state !== ButtonState.Default;

      if (isLink && linkDisabled) {
        event.preventDefault();
        event.stopPropagation(); // this should prevent any additional click handlers attached to the element from firing,
        // like if someone was attaching them via `addEventListener`. in theory this shouldn't really happen in a React ecosystem
        // (which seems to be why it is not included in the Synthetic Event) but better to be a little extra defensive in this case

        event.nativeEvent.stopImmediatePropagation();
        return;
      }

      if (!isDisabled && state === ButtonState.Default && typeof _onClick === 'function') {
        _onClick(event);
      }
    }
  };
};

export { colorForType, generateRoleRelatedProps, iconSizeForIconButton, loadingSizeForButton, loadingStateForButton };
